module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/developer/browsersync-52b00a9ae923c78ab24e943e686b70de.svg";